import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

// The openings screen: under the top bar ("Openings" and Sync) the last 30
// days' openings in a tinted band labelled "Last 30 days" (the History
// section). Only the 30 days (2026-10-09: the game bar and the selected
// game's section moved to Home, behind its stage filter). One column of
// sections bound to this screen's slot; the screen names no panel.
// Navigation is the rail's.
const bind = { sections: 'openings.sections' };

// Phosphor books, the openings entry on the navigation rail: the opening book.
const BOOKS =
  'M231.65 194.55 198.46 36.75a16 16 0 0 0-19-12.39l-46.81 10.06a16.08 16.08 0 0 0-12.3 19l33.19 157.8a16 16 0 0 0 15.63 12.78 16.23 16.23 0 0 0 3.38-.36l46.81-10.06a16.09 16.09 0 0 0 12.29-19.03ZM136 50.15v-.09l46.8-10 3.33 15.87L139.33 66Zm6.62 31.47 46.82-10.05 3.34 15.9L146 97.53Zm6.64 31.57 46.82-10.06 13.3 63.24-46.82 10.06ZM216 197.94l-46.8 10-3.33-15.87L212.67 182l3.33 15.85ZM104 32H56a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16Zm0 16v32H56V48Zm0 48v64H56V96Zm-48 112v-32h48v32Z';

export function setup(app: PiletApi) {
  app.registerPage('/openings', () => <app.Extension name="layout" params={{ layout: 'openings', bind }} />);
  app.registerExtension('rail.entries', () => null, { id: 'openings', title: 'Openings', to: '/openings', icon: BOOKS, order: 25, section: 'stages' });
  // The top bar shared by every dashboard screen: "Openings" and Sync
  // (`shared.dashboardHeader`); the band below names the period.
  app.registerExtension('openings.sections', () => <app.Extension name="shared.dashboardHeader" params={{ screen: 'Openings', period: null }} />, { order: 1 });
  // The band: the History section, the stage's top cards (Opening results,
  // Openings to work on, Opening swings) through the same slot the Overview
  // shows, then this screen's own cards on `openings.history`: Positions you
  // keep getting wrong, then the repertoire tables, kept within the cards'
  // width. (The More section, Most played and Winning openings, was folded
  // into the repertoire on 2026-10-09.)
  app.registerExtension('openings.sections', () => <app.Extension name="dashboard.band" params={{ slot: 'openings.period' }} />, { order: 2 });
  app.registerExtension(
    'openings.period',
    () => <app.Extension name="dashboard.section" params={{ title: 'History', slot: 'home.section.openings', after: 'openings.history' }} />,
    { order: 1 },
  );
}
